var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Prototype",
    {
      attrs: {
        CheckboxClass: _vm.CheckboxClass,
        className: _vm.className,
        disabled: _vm.disabled,
        value: _vm.value,
        options: _vm.options,
        keyStr: _vm.keyStr,
        reverse: _vm.reverse,
        multi: _vm.multi
      },
      on: { input: _vm.handleInput }
    },
    [
      _vm.isError
        ? _c("div", { staticClass: "errmsg" }, [_vm._v(_vm._s(_vm.errmsgVal))])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }